<header class="mobile scan">

</header>
<main class="mobile scan">
  <div id="interactive" class="viewport">
    <!-- QuaggaJS will populate this element -->
  </div>
</main>
<footer class="mobile scan">
    <a routerLink="/timeapp">
      <mat-icon class="icon-size">
        arrow_back
      </mat-icon>
    </a>
</footer>
